import { ClipLoader } from "react-spinners";
import { cn, formatAmount } from "@utils";
import { useWorkingSetPreview } from "../hooks/workingSets";
import WorkingSetIcon from "./WorkingSetIcon";

// The set's Today's tasks card, live as the conditions change: the same search Trade Accounts
// will run when the set opens there, so the numbers here are the numbers they'll see.
const WorkingSetPreview = ({ filters, name, icon, colour, duplicateOf }) => {
  const preview = useWorkingSetPreview(filters);

  return (
    <section className="flex flex-col gap-3" aria-live="polite">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-zinc-500">Preview</span>
        {preview.isFetching ? (
          <ClipLoader size={12} color="#a1a1aa" aria-label="Updating preview" />
        ) : (
          <span className="flex items-center gap-1.5 text-xs text-zinc-500">
            <span className="size-1.5 rounded-full bg-green-600" />
            Live
          </span>
        )}
      </div>

      <div
        className={cn(
          "flex flex-col gap-3 rounded-2xl border border-zinc-200 bg-white px-5 py-4 transition-opacity",
          preview.isFetching && "opacity-60",
        )}
      >
        <span className="flex min-w-0 items-center gap-2.5">
          <WorkingSetIcon icon={icon} colour={colour} className="size-7 rounded-md" iconClassName="size-3.5" />
          <span className="truncate text-sm font-medium text-zinc-900" title={name}>
            {name}
          </span>
        </span>
        {preview.isError && !preview.hasData ? (
          <span className="text-sm text-zinc-500">Couldn't load a preview. You can still create the set.</span>
        ) : (
          <span className="flex flex-col gap-1">
            <span className="text-[30px] font-semibold leading-none tabular-nums text-zinc-900">
              {preview.count ?? "—"}
            </span>
            <span className="text-sm tabular-nums text-zinc-500">
              {preview.overdue == null ? " " : formatAmount(preview.overdue)}
            </span>
          </span>
        )}
      </div>

      {preview.count === 0 && <p className="text-xs text-zinc-500">No accounts match</p>}

      {duplicateOf && (
        <p className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
          <strong>{duplicateOf.name}</strong> already uses exactly these conditions.
        </p>
      )}
    </section>
  );
};

export default WorkingSetPreview;
